import type { AxiosError } from '@ori/axios';
import { observable, action, runInAction } from 'mobx';

import { BaseStore } from './BaseStore';
import type { Configuration } from '~/models/configuration';
import type { LanguageTranslations, Localization } from '~/models/localization';

export class LocalizationStore extends BaseStore {
  @observable
  locale: string | undefined;

  @observable
  translations: LanguageTranslations = {};

  @action
  loadLocalization = async () => {
    const url = '/applications/supportCenter/localization';
    const response = await this.getUrl<Localization>(url);
    const { lang }: Configuration = this.rootStore.configurationStore.configuration;

    if (response.data) {
      const { Translations: translations }: Localization = response.data;

      runInAction(() => {
        this.translations = translations[lang] as LanguageTranslations;
      });
    }

    if (response.error !== undefined) {
      runInAction(() => {
        this.networkError = response.error as AxiosError;
      });
    }

    return response;
  };
}
